import { BrowserModule, Title } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { HttpModule } from '@angular/http';
import { IonicStorageModule } from '@ionic/storage';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicImageViewerModule } from 'ionic-img-viewer';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';

//Models
import { ProductBaseModel } from '../models/product/productbase.model';
import { UserModel } from '../models/user/user.model';
import { ProductModel } from '../models/product/product.model';
import { TransactionModel } from '../models/order/transaction.model';
import { OrderModel } from '../models/order/order.model';
import { StockLevelModel } from '../models/product/stocklevel.model';
import { SalesrepModel } from '../models/user/salesrep.model';
import { SapStatusModel } from '../models/order/sapstatus.model';
//Services
import { ErrorLogService } from '../services/errorlog.service';
import { TransactionService } from '../services/transaction.service';
import { CustomerService } from '../services/customer.service';
import { UserService } from '../services/user.service';
import { ProductService } from '../services/product.service';
import { BadgeService } from '../services/badge.service';
import { UtilService } from '../services/util.service';
import { FileService } from '../services/file.service';
import { StorageService } from '../services/storage.service';
//import { AuthService } from '../services/auth.service'
import { Setups } from '../services/setup';

import { MyApp } from './app.component';
import { PipeModule } from './pipe.module';
// import { HomePage } from '../pages/home/home';
import { APP_CONFIG, AppConfig } from '../config/app-config';

import { IonicSelectableModule } from 'ionic-selectable';
// SSO STARTS
import { MsalModule, MSAL_INSTANCE, MsalBroadcastService } from '@azure/msal-angular';
import { MsalService, MsalGuardConfiguration, MSAL_GUARD_CONFIG } from '@azure/msal-angular';
import { ENV } from '../environment/environment';
import { RouterOutlet, RouterModule, Routes } from '@angular/router';

import {
  IPublicClientApplication,
  PublicClientApplication,
  InteractionType,
  LogLevel,
} from '@azure/msal-browser';
// SSO ENDS

export function loggerCallback(logLevel: LogLevel, message: string) {
  // console.log(message);
}

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: ENV.msalConfig.auth.clientId,
      authority: ENV.msalConfig.auth.authority,
      redirectUri: ENV.apiConfig.redirectUri,
      postLogoutRedirectUri: '/',
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: true
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false,
      },
    },
  });
}

// export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
//   const protectedResourceMap = new Map<string, Array<string>>();
//   protectedResourceMap.set(
//     '/api/',
//     ENV.apiConfig.scopes
//   );

//   return {
//     interactionType: InteractionType.Redirect,
//     protectedResourceMap,
//   };
// }

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [...ENV.apiConfig.scopes],
    },
    loginFailedRoute: '/unauthorized',
  };
}

@NgModule({
  declarations: [
    MyApp
  ],
  imports: [
    BrowserModule
    , ReactiveFormsModule
    , HttpModule
    // , MyDatePickerModule
    // , MyDateRangePickerModule
    , IonicImageViewerModule
    , IonicSelectableModule
    , IonicModule.forRoot(MyApp, {
       tabsPlacement: 'top',
       platforms: {
         android: {
           tabsPlacement: 'top',
           tabsLayout: 'icon-top'
         },
         ios: {
           tabsPlacement: 'top'
         },
         windows: {
           tabsPlacement: 'top'
         }
       }
     })
    , PipeModule.forRoot()
    , IonicStorageModule.forRoot()
    , MsalModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp
  ],
  providers: [
    Title
    , { provide: APP_CONFIG, useValue: AppConfig }
    , StatusBar
    , SplashScreen
    , {provide: ErrorHandler, useClass: IonicErrorHandler}
    , ErrorLogService
    , TransactionService
    , CustomerService
    , UserService
    , ProductService
    , BadgeService
    , UtilService
    , FileService
    , StorageService
    , Setups
    , UserModel
    , ProductModel
    , TransactionModel
    , OrderModel
    , ProductBaseModel
    , StockLevelModel
    , SalesrepModel
    , SapStatusModel
    //, AuthService
    // , {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: MsalInterceptor,
    //   multi: true,
    // }
    , {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    }
    // , {
    //   provide: MSAL_GUARD_CONFIG,
    //   useFactory: MSALGuardConfigFactory,
    // }
    // , {
    //   provide: MSAL_INTERCEPTOR_CONFIG,
    //   useFactory: MSALInterceptorConfigFactory,
    // }
    , MsalService
    , MsalBroadcastService
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts